import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUrlGenerator, DefaultDataServiceConfig } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { ReconciliationModel } from './reconciliation.model';
import { Guid } from '../../shared';

export const entityName = 'Reconciliation';
@Injectable()
export class ReconciliationDataService extends EfaactDataService<ReconciliationModel> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationDataService)::`
        });
    }

    protected mapGetResponse(resp: any): any[] {
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationDataService):mapGetResponse:resp`,
            resp
        });
        return JSON.parse(resp) as any[];
    }
    mapItems(item: ReconciliationModel): ReconciliationModel {
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationDataService):mapItems`,
            item
        });
        return { ...item, id: Guid.newGuid() };
    }
}
